export enum ChatStepState {
  PENDING = 'pending',
  VIEW = 'view',
  EDIT = 'edit',
}
export enum ChatStepAction {
  NEXT = 'next',
  SKIP = 'skip',
  EDIT = 'edit',
  CANCEL = 'cancel',
  SAVE = 'save',
  SUBMIT = 'submit',
}
